<template>
    <div>
        <h3 class="mt-2 mb-3">Safety Program</h3>

        <!-- checking permissions  -->
        <template v-if="hasPermission">
            <vx-card noShadow noRound>
    
                <div>
                    <vs-row>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <vs-input
                                :value="data.id ? `#${data.id}` : 'Auto Generated'"
                                label="* ID"
                                readonly
                                class="w-full"
                            />
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <SelectDate :disabled="mode != 'e'" :selectedDate.sync="data.date" label="Date" />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.date">
                                {{ api_errors.date.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                <label for class="vs-input--label">Time of Activity(HH:MM)</label>
                                <div class="vs-con-input">
                                    <VueTimepicker auto-scroll v-model="data.time_of_activity" :disabled="mode != 'e'"></VueTimepicker>
                                </div>
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.time_of_activity">
                                {{ api_errors.time_of_activity.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <vs-input
                                label="Location"
                                class="w-full"
                                v-model="data.location"
                                :disabled="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.location">
                                {{ api_errors.location.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                            <SelectForeign
                                :model.sync="data.program_type"
                                label="Select Type of Program"
                                placeholder="Type to Search..."
                                :multiple="false"
                                :load_initial="true"
                                :label_keys="['name',]"
                                :show_id_in_label="false"
                                :endpoint="`${$store.state.apiendpoints.data_type_of_programs}?active=true`"
                                container_class="w-full"
                                input_class=""
                                :use_id_as_value="false"
                                :disabled="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.program_type">
                                {{ api_errors.program_type.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <vs-input
                                label="Beneficiaries"
                                class="w-full"
                                v-model="data.beneficiaries"
                                :disabled="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.beneficiaries">
                                {{ api_errors.beneficiaries.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                            <SelectForeign
                                :model.sync="data.assigned_reviewers"
                                label="Select Incident Manager"
                                placeholder="Type to Search..."
                                :multiple="true"
                                :load_initial="true"
                                :label_keys="['first_name', 'last_name']"
                                :show_id_in_label="false"
                                :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                                container_class="w-full"
                                input_class=""
                                :use_id_as_value="false"
                                :close_on_select="false"
                                :disabled="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                                {{ api_errors.assigned_reviewers.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                            <label class="vs-input--label block mb-1">Event Description</label>
                            <vs-textarea v-model="data.event_description" :disabled="mode != 'e'" />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.event_description">
                                {{ api_errors.event_description.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                            <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                            <FileSelection
                                :images.sync="data.images"
                                :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                                :read_only="mode != 'e'"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors.images">
                                {{ api_errors.images.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-row>
                </div>
                <vs-row class="mt-base" v-if="show_action_buttons && showReview">
                    <vs-col class="text-center">
                        <vs-button @click="reject" type="filled" color="primary" class="mx-2">
                            Reject
                        </vs-button>
                        <vs-button @click="approve" type="filled" color="primary" class="mx-2">
                            Approve
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-base" v-if="mode == 'e'">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-base" v-if="data.status == 'r'">
                    <vs-col class="text-center">
                        <span class="text-danger font-bold">Rejected By: </span> {{ data.reviewed_by.first_name || '' }} {{ data.reviewed_by.last_name || '' }} <br/>
                        <span class="text-black font-bold">Comment: </span>{{ data.comments || "No Comment" }}
                    </vs-col>
                </vs-row>
                <vs-row class="mt-base" v-if="mode == 'v' && data.status == 'a'">
                    <vs-col class="text-center">
                        <span class="text-success font-bold">Approved By: </span> {{ data.reviewed_by.first_name || '' }} {{ data.reviewed_by.last_name || '' }} <br/>
                        <span class="text-success font-bold">Assigned to:</span>
                        <template v-if="data.resource_allocation == 'e'">
                            {{ data.allocated_resource.first_name }} {{ data.allocated_resource.last_name }} (Vendor),
                        </template>
                        {{ data.allocated_engineer.first_name }} {{ data.allocated_engineer.last_name }} (Employee)
                    </vs-col>
                </vs-row>
            </vx-card>
            <RejectionPopup :is_active.sync="reject_popup.active" :api_errors="reject_popup.api_errors" :submit="do_reject" />
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import FileSelection from "../Issue/Components/FileSelection.vue";
import SelectDate from "../../components/letstream/ls-select-date/SelectDate.vue";
import RejectionPopup from "../Issue/Components/RejectionPopup.vue";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import { Request } from "../../utils/requests";

export default {

    props: {
        mode: {
            required: true,
            type: String
        }
    },
    data() {
        return {

            safety_program_id: this.$route.params.safety_program_id,

            data: {
                id: null,

                date: new Date(Date.now()),
                time_of_activity: '',
                location: null,
                program_type: null,
                beneficiaries: null,
                event_description: null,

                reported_by: this.$store.state.organisation.organisation_user,
                assigned_reviewers: [],
                created_on: new Date().toISOString(),
                images: []
            },

            submit_disabled: false,
            api_errors: {},
            reject_popup: {
                active: false,
                api_errors: {}
            }

        }
    },
    mounted() {
        this.init()
    },
    computed: {
        show_action_buttons () {
            if (this.mode != 'v') return false

            if (this.data.status != 'p') return false
            
            return true
        },
        viewSafetyProgram() {
            let user_ids = this.data.assigned_reviewers.map(v=>v.id)
            user_ids.push(this.data.reported_by.id)
            return this.hasAccess('read', `safety_program`, 'any', user_ids)
        },
        createSafetyProgram() { 
            return this.hasAccess('create', `safety_program`, 'all') 
        },
        editSafetyProgram() { 
            return this.hasAccess('edit', `safety_program`, ['all', 'own'], [this.data.reported_by.id]) 
        },
        showReview() { 
            return this.hasAccess('review', `safety_program`, ['all', 'assigned'], this.data.assigned_reviewers.map(v=>v.id)) 
        },
        hasPermission() {
            return (!this.data.id && this.createSafetyProgram) || (this.data.id && this.mode=='e' && this.editSafetyProgram) || (this.data.id && this.mode=='v' && this.viewSafetyProgram)
        }
    },
    methods: {
        init() {
            if(this.safety_program_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.safety_program + this.safety_program_id + '/'

            this.$vs.loading()

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.data = res
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.safety_program
            if (this.data.id) {
                request_method = 'PUT'
                url += this.data.id + '/'
            }

            let payload = {
                ...this.data,
                images: null
            }

            if (this.data.images.length == 0 && this.data.images.filter(v => typeof(v.image) != 'string').length == 0) {
                this.api_errors = {
                    "images": [
                        "Please select atleast 1 image",
                    ]
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Please fix the errors and try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
                return
            }

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                async res => {
                    try {

                        await this.upload_images(res.id)
                        this.data = {...res, images: this.data.images}

                        this.submit_disabled = false

                        this.$vs.notify({
                            time: 3000,
                            title: 'Saved',
                            text: "Saved Successfully!",
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        this.$router.push({name: 'safety-program-list'})
                    } catch (e) {
                        this.submit_disabled = false
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An erorr occurred while uploading images. Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        },
        async upload_images(id) {
            for (let i=0; i < this.data.images.length; i++) {
                this.$set(this.data.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(id, this.data.images[i])
                    this.$set(this.data.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.data.images, i, data)
                } catch (e) {
                    this.$set(this.data.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', 'p')

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_image, id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )

            })
        },
        do_reject(data) {
            let payload = {
                action: 'reject',
                comment: data.comment
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.reject_popup.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.data.id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false
                    this.reject_popup.active = false
                    this.reject_popup.api_errors = {}

                    this.init()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.reject_popup.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.reject_popup.active = false
                    }
                }
            )
        },
        approve() {
            this.$router.push({name: 'safety-program-approve', params: {safety_program_id: this.data.id}})
        },
        reject () {
            this.reject_popup.active = true
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__safety_program`)
            permission.push(`review__assigned__safety_program`)

            return permission.toString()
        }
    },
    components: {
        FileSelection, SelectDate, RejectionPopup, VueTimepicker
    }
}
</script>

<style>
</style>
